

















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'

@Component({
  components: { Radio }
})
export default class RadioCard extends Vue {
  @Prop({ default: '' }) readonly icon!: string
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop({ default: '' }) readonly value!: string
  @Prop({ default: '' }) readonly radioValue!: string
  @Prop({ default: '' }) readonly description!: string

  radio = this.value

  get check() {
    this.radio = this.value
    return this.radio === this.radioValue
  }

  updateValue(radioValue) {
    if (this.disabled) return
    return this.$emit('input', radioValue)
  }

}
